<!--
 * @Description: 是否需要执行人上传资质证明组件
 * @Date: 2023-08-25 14:06:21
-->
<template>
  <div class="qualification">
    <el-form-item label="">
      <div class="flex" v-for="(item1, index) in selectArr" :key="index">
        <div v-if="!disabled">
          <el-select
            :disabled="disabled"
            @visible-change="selectClickOuter(index)"
            v-model="item1.value"
            placeholder="请选择需要上传的资质"
            @change="handlechangeOuter"
          >
            <el-option
              v-for="opt in selectOptionsData"
              :key="opt.id"
              :label="opt.certificationName"
              :disabled="setDisabled(opt, index)"
              :value="opt.id"
            ></el-option>
          </el-select>
        </div>
        <div v-else>
          <el-input
            :disabled="disabled"
            v-model="item1.certificationName"
          ></el-input>
        </div>
        <!-- /前面一个删除图标 -->
        <div class="flexAlign">
          <i
            @click="frontDelIcon(index)"
            v-if="
              item1.children.length == 0 && !disabled && selectArr.length > 1
            "
            class="el-icon-error fontDel"
          ></i>
        </div>
        <div>
          <div
            class="flexAlign"
            v-for="(item3, index3) in item1.children"
            :key="index3"
          >
            <div class="orIcon1">
              或
            </div>
            <el-select
              v-if="!disabled"
              :disabled="disabled"
              @change="handlechangeOuter"
              v-model="item3.value"
              placeholder="请选择需要上传的资质"
            >
              <el-option
                v-for="opt in selectOptionsData"
                :key="opt.id"
                :disabled="setDisabled(opt, index)"
                :label="opt.certificationName"
                :value="opt.id"
              ></el-option>
            </el-select>
            <el-input
              :disabled="disabled"
              v-else
              v-model="item3.certificationName"
            ></el-input>
            <div class="flex">
              <!-- 删除图标 -->
              <i
                v-if="!disabled"
                @click="lastDelIcon(index, index3)"
                class="el-icon-error lastDelicon"
              ></i>
            </div>
          </div>
        </div>
      </div>
      <el-divider v-if="!disabled && selectArr[0].value !== ''"></el-divider>
      <div class="iconAddOr" v-if="!disabled && selectArr[0].value !== ''">
        <div class="flexAlign" v-if="selectArr.length < 5">
          <!-- 添加图标 -->
          <i @click="addIcon" class="el-icon-circle-plus addIcon"></i>
        </div>
        <div v-if="orNuber < 25">
          <div @click="orIcon" class="orIcon">
            或
          </div>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import { projectPersonnelManagement } from '@/api/ajax';
export default {
  components: {},
  props: {
    certificationClassifyList: {
      type: [Array, String]
    },
    disabled: {
      type: Boolean
    }
  },
  model: {
    prop: 'certificationClassifyList',
    event: 'vMdoleData'
  },
  watch: {
    selectArr: {
      deep: true,
      handler() {
        this.$emit('selectOptionsDataEvent', this.updateData);
        this.$emit('vMdoleData', this.vModelData);
      }
    }
  },
  computed: {
    setDisabled() {
      return opt => {
        let newArr = [];
        this.selectArr.forEach(item1 => {
          newArr.push(item1.value);
          item1.children.forEach(item2 => {
            newArr.push(item2.value);
          });
        });
        return newArr.includes(opt.id);
      };
    },

    //组装后端需要的数据格式
    updateData() {
      let dataArr = [];
      let arr = [];
      this.selectArr.forEach((item, index) => {
        if (item.value !== '') {
          arr.push(item.value);
          item.children.forEach(item2 => {
            if (item2.value !== '') {
              arr.push(item2.value);
            }
          });
          dataArr[index] = arr;
          arr = [];
        }
        // arr.push(item.value);
        // item.children.forEach(item2 => {
        //   arr.push(item2.value);
        // });
        // dataArr[index] = arr;
        // arr = [];
      });
      return dataArr.join('_');
    },
    vModelData() {
      let vMdataArr = [];
      let arr = [];
      this.selectArr.forEach(item => {
        item.certificationId = item.value;
        arr.push(item);
        if (item.children && item.children.length != 0) {
          item.children.forEach(chItem => {
            chItem.certificationId = chItem.value;
            arr.push(chItem);
          });
        }

        vMdataArr.push(arr);
        arr = [];
      });
      return vMdataArr;
    }
  },
  data() {
    //这里存放数据
    return {
      orNuber: 0,
      actionIndex: '',
      selectOptionsData: [], //每一个下拉框
      selectArr: [
        //组件的总数据
        {
          children: [
            // {
            //   value: ''
            // }
          ],
          value: ''
        }
      ]
    };
  },
  methods: {
    selectData() {
      projectPersonnelManagement.queryCertificationListAll().then(res => {
        const arr = res.data.data;
        try {
          const keys = arr.reduce((pre, cur) => {
            pre.set(cur.id, cur);
            return pre;
          }, new Map());
          this.certificationClassifyList.flat().forEach(item => {
            if (!keys.has(item.certificationId)) {
              arr.push({
                certificationName: item.certificationName,
                id: item.certificationId
              });
            }
          });
        } catch (error) {
          console.warn(error);
        }
        this.selectOptionsData = arr;
      });
    },
    handlechangeOuter() {
      this.$emit('selectOptionsDataEvent', this.updateData);
      this.$emit('vMdoleData', this.vModelData);
    },

    //前面一个删除图标
    frontDelIcon(indexs) {
      console.log('this.selectArr', this.selectArr.length);
      this.selectArr.forEach((item, index) => {
        if (index == indexs && this.selectArr.length > 1) {
          this.selectArr.splice(indexs, 1);
        }
      });
      this.$emit('selectOptionsDataEvent', this.updateData);
      this.$emit('vMdoleData', this.vModelData);
    },
    //后面一个删除图标
    lastDelIcon(indexs, index3) {
      this.actionIndex = indexs;
      let nuber = 0;
      this.selectArr.forEach((item, index) => {
        item.children.forEach((item2, index2) => {
          if (index == indexs && index2 == index3) {
            item.children.splice(index3, 1);
          }
        });
        nuber += item.children.length;
      });
      this.orNuber = nuber;
      this.$emit('selectOptionsDataEvent', this.updateData);
      this.$emit('vMdoleData', this.vModelData);
    },
    selectClickOuter(indexs) {
      this.actionIndex = indexs;

      this.$emit('selectOptionsDataEvent', this.updateData);
      this.$emit('vMdoleData', this.vModelData);
    },

    addIcon() {
      console.log('vModelData00', this.vModelData);
      this.actionIndex = '';
      if (this.selectArr.length <= 4) {
        this.selectArr.push({
          children: [],
          value: ''
        });
      }
      this.$emit('selectOptionsDataEvent', this.updateData);
      this.$emit('vMdoleData', this.vModelData);
    },
    orIcon() {
      if (this.selectArr.length === 1) {
        this.actionIndex = 0;
      }
      let nuber = 0;
      this.selectArr.forEach((item, index) => {
        if (
          index == this.actionIndex &&
          [index].includes(this.actionIndex) &&
          item.children.length < 5 &&
          item.value !== ''
        ) {
          item.children.push({
            value: ''
          });
        } else {
          if (
            this.selectArr.length - 1 == index &&
            [index, ''].includes(this.actionIndex) &&
            item.children.length < 5 &&
            item.value !== ''
          ) {
            item.children.push({
              value: ''
            });
          }
        }
        nuber += item.children.length;
      });
      this.orNuber = nuber;
      this.$emit('selectOptionsDataEvent', this.updateData);
      this.$emit('vMdoleData', this.vModelData);
    }
  },
  created() {
    this.selectData();
    console.log(
      'this.certificationClassifyList--',
      this.certificationClassifyList
    );
    let newselectArr = [];
    //初始化回显数据
    if (this.certificationClassifyList.length != 0) {
      JSON.parse(JSON.stringify(this.certificationClassifyList)).forEach(
        (item, index) => {
          item.forEach((chItem, chIndex) => {
            chItem.value = chItem.certificationId;
            if (chIndex == 0) {
              chItem.children = [];
              newselectArr.push(chItem);
            } else {
              newselectArr[index].children.push(chItem);
            }
          });
        }
      );
      this.selectArr = JSON.parse(JSON.stringify(newselectArr));
    }
  },

  mounted() {}
};
</script>
<style lang="scss" scoped>
.qualification {
  .fontDel {
    color: red;
    font-size: 30px;
    cursor: pointer;
    margin-left: 15px;
  }
  .orIcon1 {
    border-radius: 50%;
    cursor: pointer;
    background-color: #0f7cfa;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    margin: 0 20px;
  }
  .orIcon {
    border-radius: 50%;
    cursor: pointer;
    background-color: #0f7cfa;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    margin-left: 10px;
  }
  .lastDelicon {
    color: red;
    font-size: 30px;
    cursor: pointer;
    margin-left: 10px;
  }
  .iconAddOr {
    display: flex;
    margin-top: 20px;
    .addIcon {
      color: red;
      font-size: 32px;
      cursor: pointer;
    }
    .orIcon {
      border-radius: 50%;
      cursor: pointer;
      background-color: #0f7cfa;
      width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color: #fff;
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.flexAlign {
  display: flex;
  align-items: center;
}
</style>
